export default __webpack_public_path__ + "static/media/banner.e551a569.jpg";